import { create } from 'apisauce';

const baseURL = import.meta.env.VITE_APP_TASKDB_BACKEND
const backendAPI = create({
    baseURL: baseURL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
})

const fieldsPlanning = import.meta.env.VITE_APP_FIELD_PLANNING_BACKEND
export const fieldsAPI = create({
    baseURL: fieldsPlanning,
    headers: {
        Accept: 'application/json',
        //'Content-Type': 'application/json',
    }
})


export default backendAPI